<template>
    <div>
        <b-card class="sa-card sa-card-border mb-3" header="Ripetizione (RIP)" header-tag="header">

            <b-card class="sa-card sa-card-border mb-3" header="Parte prima: Suoni" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. /a:/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniUno" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniUnoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. /o:/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniDue" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniDuePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. /ɛ:/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniTre" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniTrePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. /au/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniQuattro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniQuattroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. /t/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniCinque" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniCinquePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. /p/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniSei" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniSeiPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. /g/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniSette" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniSettePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. /ʃ/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniOtto" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniOttoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. /v/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniNove" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniNovePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. /ŋ/</label>
                                <b-form-input v-model="jsonDataRipetizione.suoniDieci" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.suoniDieciPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte I</label>
                        <b-form-input :value="jsonDataRipetizione.suoniPartePrimaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte seconda: Parole" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Ago</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleAgo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleAgoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Lupo</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleLupo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleLupoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Elmo</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleElmo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleElmoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Festa</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleFesta" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleFestaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Ombra</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleOmbra" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleOmbraPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Spinta</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleSpinta" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleSpintaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Nastro</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleNastro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleNastroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Scrigno</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleScrigno" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleScrignoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Granchio</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleGranchio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleGranchioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Stringa</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleStringa" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleStringaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte II</label>
                        <b-form-input :value="jsonDataRipetizione.paroleParteSecondaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte terza: Prestiti e parole straniere" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Bar</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiBar" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiBarPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Film</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiFilm" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiFilmPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Tram</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiTram" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiTramPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Sport</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiSport" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiSportPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Sprint</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiSprint" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiSprintPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Valzer</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiValzer" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiValzerPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Slalom</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiSlalom" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiSlalomPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Strudel</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiStrudel" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiStrudelPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Gangster</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiGangster" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiGangsterPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Transistor</label>
                                <b-form-input v-model="jsonDataRipetizione.prestitiTransistor" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.prestitiTransistorPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte III</label>
                        <b-form-input :value="jsonDataRipetizione.prestitiParteTerzaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte quarta: Parole composte e sintagmi (tra parentesi: numero di sillabe)" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Divieto (3)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteDivieto" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteDivietoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Capogiro (4)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteCapogiro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteCapogiroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Deformazione (5)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteDeformazione" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteDeformazionePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Contachilometri (6)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteContachilometri" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteContachilometriPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Irresponsabilità (7)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteIrresponsabilita" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteIrresponsabilitaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Ferro da stiro a vapore (9)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteFerroStiroVapore" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteFerroStiroVaporePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Diritto di primogenitura (10)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteDirittoPrimogenitura" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteDirittoPrimogenituraPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Modulo per conto corrente postale (12)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteModuloContoCorrentePostale" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteModuloContoCorrentePostalePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Sentenza di incostituzionalità</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteSentenzaIncostituzionalita" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteSentenzaIncostituzionalitaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Verbale di multa per auto in sosta vietata (15)</label>
                                <b-form-input v-model="jsonDataRipetizione.paroleComposteVerbaleMultaSostaVietata" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.paroleComposteVerbaleMultaSostaVietataPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte IV</label>
                        <b-form-input :value="jsonDataRipetizione.paroleComposteParteQuartaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte quinta: Frasi (tra parentesi: numero di parole)" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Il gallo canta (3)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiGalloCanta" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiGalloCantaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. La piccola parla già (4)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiPiccolaParlaGia" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiPiccolaParlaGiaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Siamo stati invitati da lui (5)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiSiamoStatiInvitatiLui" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiSiamoStatiInvitatiLuiPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Io non ti presto più l’auto (7)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiIoNonTiPrestoPiuAuto" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiIoNonTiPrestoPiuAutoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Carlo non si fa mai tagliare i capelli (8)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiCarloNonSiFaTagliareCapelli" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiCarloNonSiFaTagliareCapelliPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Mi ha promesso di passare oggi stesso (7)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiPromessoPassareOggi" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiPromessoPassareOggiPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Lui non è affatto facile da accontentare (7)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiLuiDifficileAccontentare" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiLuiDifficileAccontentarePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Ha incontrato al supermercato la sua vicina con un cappotto nuovo (11)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiVicinaSupermercato" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiVicinaSupermercatoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. È stato detto che sempre più persone bevono birra</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiPersoneBevonoBirra" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiPersoneBevonoBirraPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. L’uomo che comprò la nostra auto è da ieri ammalato (11)</label>
                                <b-form-input v-model="jsonDataRipetizione.frasiUomoAutoAmmalato" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataRipetizione.frasiUomoAutoAmmalatoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte V</label>
                        <b-form-input :value="jsonDataRipetizione.frasiParteQuintaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>

            <b-row>
                <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Punteggio totale (parti I–V)</label>
                    <b-form-input :value="jsonDataRipetizione.ripetizionePunteggioTotale" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "RsaSchedaAachenerAphasieTestRipetizioneEditComponent",
    props: {
        jsonDataRipetizione: { type: Object, required: true },
        isReadOnly: { type: Boolean, default: false },
    },
    data() {
        return {
            punteggioOptions: [
                { value: null, text: "- Seleziona valore -", disabled: true },
                0, 1, 2, 3,
            ],
        };
    },
};
</script>

<style scoped>
.aat-field {
    margin-bottom: 1rem;
}
.aat-field .sa-label-data {
    align-items: flex-end;
    display: flex;
    min-height: 2.5rem;
}
</style>
